import React, { useState } from "react";
import { faImage } from "@fortawesome/free-regular-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { useForm } from "react-hook-form";
import TableFixedPage from "../../../TableFixedPage/TableFixedPage";
import { AddUserPostApi } from "../../../../Api/PanelAdminServices";
import Style from "./AddAdminContainer.module.scss";
import Resizer from "react-image-file-resizer";
import Select from "react-select";
import "../AddSupplierContainer/AddSupplier.css";
import { errorToast, succToast } from "../../../../Utils/Toast/Toast";

const AddAdminContainer = () => {
  const [photo, setPhoto] = useState("");
  const [disable, setDisable] = useState(false);
  const [chooseAccess, setChooseAccess] = useState("");
  const accessLevel = [
    {
      value: "1",
      label: "ادمین اصلی",
      status:"0"
    },
    {
      value: "2",
      label: "نمیدونم",
      status:"1"
    },
    {
      value: "3",
      label: "پشتیبانی",
      status:"2"
    },
  ];
  //////آپلود کردن عکس
  const UploadPhoto = async (image) => {
    return await resizeFileLogo(image);
  };
  /////ریسایز کردن logo برای آپلود
  const resizeFileLogo = (file) =>
    new Promise((resolve) => {
      Resizer.imageFileResizer(
        file,
        1024,
        1024,
        "WEBP",
        100,
        0,
        (uri) => {
          setPhoto(uri);
        },
        "base64"
      );
    });
  //////validation input //////////
  const {
    register,
    handleSubmit,
    formState: { errors },
  } = useForm();

  const onsubmit = (data) => {
    let info = {
      first_name: data.name,
      last_name: data.lName,
      phone: data.phone,
      national_code: data.nationalcode,
      email: data.email ? data.email : "",
      access_level: chooseAccess.status,
      password: data.password,
      user_type: "admin",
      photo: photo,
    };
    console.log(info);
    AddUserPostApi(info, (res) => {
      if(res.status===1){
        succToast(res.message)
        setDisable(false)
      }else{
        errorToast(res.message)
        setDisable(false)
      }
    });
  };
  return (
    <div className={Style.componentHolder}>
      <TableFixedPage title={"افزودن ادمین "} />
      <form onSubmit={handleSubmit(onsubmit)} className={Style.formPart}>
        <div className={Style.inputHolder}>
          <section className={Style.logoPart}>
            <div className={Style.titleLogo}>بارگذاری لوگو</div>
            <div className={Style.uploadImage}>
              <img src={photo} alt="" />
            </div>
            <input
              id={"uploadPhoto"}
              type="file"
              style={{ display: "none" }}
              onChange={(e) => UploadPhoto(e.target.files[0])}
            />
            <label htmlFor={"uploadPhoto"} className={Style.iconHolder}>
              <FontAwesomeIcon className={Style.icon} icon={faImage} />
            </label>
            <h3 className={Style.textLogo}>بارگذاری تصویر</h3>
          </section>

          <input
            className={errors.name ? Style.errorInput : Style.inputPart}
            placeholder={"نام"}
            {...register("name", { required: true })}
          />

          <input
            className={errors.lName ? Style.errorInput : Style.inputPart}
            placeholder={"نام خانوادگی "}
            {...register("lName", { required: true })}
          />
          <input
            className={errors.phone ? Style.errorInput : Style.inputPart}
            placeholder={"شماره همراه"}
            {...register("phone", { required: true })}
          />
          <Select
            onChange={setChooseAccess}
            options={accessLevel}
            placeholder={" سطح دسترسی"}
            className={Style.selectPart}
          />
          <input
            className={errors.password ? Style.errorInput :Style.inputPart}
            placeholder={"رمز"}
            {...register("password", { required: true })}
          />
          <input
            className={Style.inputPart}
            placeholder={"ایمیل "}
            {...register("email")}
          />
          <input
            className={errors.nationalcode ? Style.errorInput : Style.inputPart}
            placeholder={"کدملی "}
            {...register("nationalcode", { required: true })}
          />

          <button className={Style.btnStyle} type={"submit"} disabled={disable}>
            اضافه کردن
          </button>
        </div>
      </form>
    </div>
  );
};

export default AddAdminContainer;
